import React from "react";
import "../css/SoulsMonthTheme.css";

/** Souls Month (Undas / trick-or-treat season) */
export const isSoulsMonth = () => {
  const month = new Date().getMonth() + 1;
  return month === 11;
};

/* ------------------------------------------------------------------ */
/* Cobweb — corner web, drawn with radial threads + sagging rings      */
/* ------------------------------------------------------------------ */
const Cobweb = ({ side = "left" }) => (
  <svg
    className={`souls-web souls-web--${side}`}
    viewBox="0 0 200 200"
    aria-hidden="true"
    focusable="false"
  >
    <g
      className="souls-web__threads"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M0 0 L200 0" />
      <path d="M0 0 L188 70" />
      <path d="M0 0 L150 150" />
      <path d="M0 0 L70 188" />
      <path d="M0 0 L0 200" />

      <path d="M55 0 Q47.7 8.4 51.5 19.2 Q40.8 26 38.9 38.9 Q26 40.8 19.2 51.5 Q8.4 47.7 0 55" />
      <path d="M95 0 Q82.3 14.5 89 33.2 Q70.5 44.9 67.2 67.2 Q44.9 70.5 33.2 89 Q14.5 82.3 0 95" />
      <path d="M140 0 Q121.3 21.4 131.2 48.9 Q103.9 66.2 99 99 Q66.2 103.9 48.9 131.2 Q21.4 121.3 0 140" />
      <path d="M185 0 Q160.4 28.3 173.3 64.6 Q137.2 87.4 130.8 130.8 Q87.4 137.2 64.6 173.3 Q28.3 160.4 0 185" />
    </g>
  </svg>
);

/* ------------------------------------------------------------------ */
/* Spider — cartoon, drops on a 3s loop                                */
/* ------------------------------------------------------------------ */
const Spider = ({ side = "right" }) => (
  <div className={`souls-spider souls-spider--${side}`} aria-hidden="true">
    <div className="souls-spider__thread" />
    <svg
      className="souls-spider__body"
      viewBox="0 0 120 110"
      focusable="false"
      aria-hidden="true"
    >
      <g
        className="souls-spider__legs souls-spider__legs--l"
        fill="none"
        stroke="#17151f"
        strokeWidth="5"
        strokeLinecap="round"
      >
        <path d="M46 48 C 24 40, 14 46, 8 62" />
        <path d="M44 58 C 20 56, 8 62, 4 78" />
        <path d="M45 68 C 22 72, 12 80, 12 94" />
        <path d="M49 76 C 32 86, 26 94, 28 104" />
      </g>
      <g
        className="souls-spider__legs souls-spider__legs--r"
        fill="none"
        stroke="#17151f"
        strokeWidth="5"
        strokeLinecap="round"
      >
        <path d="M74 48 C 96 40, 106 46, 112 62" />
        <path d="M76 58 C 100 56, 112 62, 116 78" />
        <path d="M75 68 C 98 72, 108 80, 108 94" />
        <path d="M71 76 C 88 86, 94 94, 92 104" />
      </g>

      <ellipse cx="60" cy="72" rx="26" ry="23" fill="#1d1a27" />
      <ellipse cx="60" cy="66" rx="18" ry="8" fill="#2c2739" opacity="0.8" />
      <circle cx="60" cy="44" r="20" fill="#26212f" />

      <circle cx="52" cy="41" r="8" fill="#fdfbff" />
      <circle cx="68" cy="41" r="8" fill="#fdfbff" />
      <circle
        className="souls-spider__pupil"
        cx="53"
        cy="43"
        r="4"
        fill="#15121c"
      />
      <circle
        className="souls-spider__pupil"
        cx="69"
        cy="43"
        r="4"
        fill="#15121c"
      />
      <circle cx="51" cy="40" r="1.6" fill="#fff" />
      <circle cx="67" cy="40" r="1.6" fill="#fff" />
      <path
        d="M54 54 Q60 59 66 54"
        fill="none"
        stroke="#15121c"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

/* ------------------------------------------------------------------ */
/* Jack-o'-lantern                                                     */
/* ------------------------------------------------------------------ */
const Pumpkin = ({ className = "" }) => (
  <svg
    className={`souls-pumpkin ${className}`}
    viewBox="0 0 160 150"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M80 30 C 78 18, 74 10, 64 6"
      fill="none"
      stroke="#4f7a2e"
      strokeWidth="7"
      strokeLinecap="round"
    />
    <path d="M74 32 q6 -14 14 -2 q-4 6 -14 2z" fill="#6b4a22" />

    <ellipse cx="80" cy="88" rx="58" ry="52" fill="#e0701b" />
    <ellipse cx="46" cy="88" rx="26" ry="50" fill="#c95f14" opacity="0.55" />
    <ellipse cx="114" cy="88" rx="26" ry="50" fill="#c95f14" opacity="0.55" />
    <ellipse cx="80" cy="88" rx="24" ry="52" fill="#f0862c" opacity="0.7" />

    <g className="souls-pumpkin__face" fill="#ffd25e">
      <path d="M50 74 l24 12 -24 8z" />
      <path d="M110 74 l-24 12 24 8z" />
      <path d="M46 104 q34 26 68 0 q-10 6 -14 0 q-8 8 -14 0 q-6 8 -12 0 q-6 6 -14 0 q-8 6 -14 0z" />
    </g>
  </svg>
);

/* ------------------------------------------------------------------ */
/* Bats — flapping, drifting across the header                         */
/* ------------------------------------------------------------------ */
const Bat = () => (
  <svg viewBox="0 0 140 70" aria-hidden="true" focusable="false">
    <g className="souls-bat__wing souls-bat__wing--l" fill="#1a1522">
      <path d="M66 34 C 48 14, 30 12, 10 20 q12 6 8 16 q10 -6 16 2 q8 -4 12 6 q8 -6 20 -10z" />
    </g>
    <g className="souls-bat__wing souls-bat__wing--r" fill="#1a1522">
      <path d="M74 34 C 92 14, 110 12, 130 20 q-12 6 -8 16 q-10 -6 -16 2 q-8 -4 -12 6 q-8 -6 -20 -10z" />
    </g>

    <ellipse cx="70" cy="40" rx="11" ry="15" fill="#241d2e" />
    <circle cx="70" cy="26" r="11" fill="#2b2336" />
    <path d="M61 19 l-2 -12 10 7z" fill="#2b2336" />
    <path d="M79 19 l2 -12 -10 7z" fill="#2b2336" />
    <circle cx="66" cy="26" r="2.6" fill="#ffd25e" />
    <circle cx="74" cy="26" r="2.6" fill="#ffd25e" />
  </svg>
);

const Bats = () => (
  <div className="souls-bats" aria-hidden="true">
    <span className="souls-bat souls-bat--1">
      <Bat />
    </span>
    <span className="souls-bat souls-bat--2">
      <Bat />
    </span>
    <span className="souls-bat souls-bat--3">
      <Bat />
    </span>
  </div>
);

/* ------------------------------------------------------------------ */
/* Blood rain — a light drizzle, not a downpour                        */
/* ------------------------------------------------------------------ */
export const BloodRain = () => {
  if (!isSoulsMonth()) return null;

  const drops = [
    { left: "8%", delay: 0, duration: 4.2 },
    { left: "21%", delay: 2.6, duration: 5.4 },
    { left: "34%", delay: 1.1, duration: 4.8 },
    { left: "47%", delay: 3.8, duration: 6 },
    { left: "59%", delay: 0.6, duration: 5 },
    { left: "71%", delay: 2.2, duration: 4.4 },
    { left: "84%", delay: 4.4, duration: 5.8 },
    { left: "93%", delay: 1.7, duration: 5.2 },
  ];

  return (
    <div className="souls-blood-rain" aria-hidden="true">
      {drops.map((d, i) => (
        <span
          key={i}
          className="souls-drop"
          style={{
            left: d.left,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/* Drifting ghosts (background)                                        */
/* ------------------------------------------------------------------ */
const GhostShape = () => (
  <svg viewBox="0 0 60 70" aria-hidden="true" focusable="false">
    <path
      d="M30 4 C 14 4 6 16 6 32 v30 q6 6 12 0 q6 -6 12 0 q6 6 12 0 q6 -6 12 0 V32 C 54 16 46 4 30 4z"
      fill="#e8e6ff"
    />
    <circle cx="22" cy="30" r="4" fill="#2a2440" />
    <circle cx="38" cy="30" r="4" fill="#2a2440" />
    <ellipse cx="30" cy="42" rx="5" ry="6" fill="#2a2440" opacity="0.8" />
  </svg>
);

export const FloatingGhosts = () => {
  if (!isSoulsMonth()) return null;

  const ghosts = [
    { left: "15%", delay: 0, duration: 11 },
    { left: "45%", delay: 3.5, duration: 13 },
    { left: "78%", delay: 6.5, duration: 10 },
  ];

  return (
    <div className="souls-ghosts-container" aria-hidden="true">
      {ghosts.map((g, i) => (
        <span
          key={i}
          className="souls-ghost"
          style={{
            left: g.left,
            animationDelay: `${g.delay}s`,
            animationDuration: `${g.duration}s`,
          }}
        >
          <GhostShape />
        </span>
      ))}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/* Walking ghost — black witch hat, carrying a jack-o'-lantern.        */
/* Faces right; the wrapper flips it on the way back.                  */
/* Draw order: back arm → body → face → pumpkin → front arm (holds it) */
/* ------------------------------------------------------------------ */
const WalkingGhostShape = () => (
  <svg viewBox="0 0 80 100" aria-hidden="true" focusable="false">
    <ellipse cx="38" cy="96" rx="20" ry="3" fill="#1a1522" opacity="0.18" />

    <path d="M18 56 q-9 6 -7 15 q5 -2 9 -8z" fill="#dcd9f5" />
    <path
      d="M38 24 C 22 24 14 36 14 52 v34 q6 6 12 0 q6 -6 12 0 q6 6 12 0 q6 -6 12 0 V52 C 62 36 54 24 38 24z"
      fill="#f4f2ff"
      stroke="#cfcbea"
      strokeWidth="1.5"
    />

    {/* face */}
    <ellipse cx="37" cy="44" rx="3.4" ry="4.4" fill="#2a2440" />
    <ellipse cx="49" cy="44" rx="3.4" ry="4.4" fill="#2a2440" />
    <circle cx="38" cy="42.5" r="1.1" fill="#fff" />
    <circle cx="50" cy="42.5" r="1.1" fill="#fff" />
    <ellipse cx="33" cy="51" rx="3.2" ry="1.8" fill="#f5a3b8" opacity="0.6" />
    <ellipse cx="54" cy="51" rx="3.2" ry="1.8" fill="#f5a3b8" opacity="0.6" />
    <path
      d="M40 52 q3 3.5 6 0"
      fill="none"
      stroke="#2a2440"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    {/* witch hat — cone with a bent tip, orange band, wide brim */}
    <path
      d="M27 27 Q33 16 35 7 Q38 0 47 3 Q41 6 43 13 Q46 21 50 27z"
      fill="#1a1522"
    />
    <path d="M28.5 22.5 h20 l1.5 4 h-23z" fill="#e0701b" />
    <ellipse cx="38.5" cy="27.5" rx="20" ry="4" fill="#1a1522" />

    {/* jack-o'-lantern carried in front */}
    <g className="souls-walker__pumpkin">
      <path
        d="M58 56 q0 -4 3 -6"
        fill="none"
        stroke="#4f7a2e"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <ellipse cx="58" cy="66" rx="12" ry="10" fill="#e0701b" />
      <ellipse cx="52" cy="66" rx="5" ry="9.5" fill="#c95f14" opacity="0.55" />
      <ellipse cx="64" cy="66" rx="5" ry="9.5" fill="#c95f14" opacity="0.55" />
      <g className="souls-pumpkin__face" fill="#ffd25e">
        <path d="M52 63 l4 2 -4 2z" />
        <path d="M64 63 l-4 2 4 2z" />
        <path d="M52 70 q6 5 12 0 q-3 1.5 -4 0 q-2 1.5 -4 0 q-2 1.5 -4 0z" />
      </g>
    </g>

    <path d="M56 56 q11 2 12 12 q-6 0 -10 -5z" fill="#e8e6ff" />
  </svg>
);

const WalkingGhost = () => (
  <div className="souls-walk-path" aria-hidden="true">
    <div className="souls-walker">
      <div className="souls-walker__bob">
        <WalkingGhostShape />
      </div>
    </div>
  </div>
);

/* ------------------------------------------------------------------ */
/* Crescent moon — soft glow, the bats fly around it                   */
/* ------------------------------------------------------------------ */
const Moon = () => (
  <svg className="souls-moon" viewBox="0 0 40 40" aria-hidden="true">
    <defs>
      <mask id="souls-moon-cut">
        <rect width="40" height="40" fill="#fff" />
        <circle cx="27" cy="15" r="13" fill="#000" />
      </mask>
    </defs>
    <circle cx="20" cy="20" r="15" fill="#fbe7a1" mask="url(#souls-moon-cut)" />
    <circle cx="12" cy="24" r="2" fill="#e8cf7c" opacity="0.7" />
    <circle cx="16" cy="31" r="1.4" fill="#e8cf7c" opacity="0.6" />
  </svg>
);

/* ------------------------------------------------------------------ */
/* Soul lights — little glowing wisps wandering across the header      */
/* ------------------------------------------------------------------ */
const WISPS = [
  { left: "22%", bottom: "30px", delay: 0, duration: 9, hue: "teal" },
  { left: "31%", bottom: "58px", delay: 2.4, duration: 11, hue: "violet" },
  { left: "40%", bottom: "18px", delay: 5.1, duration: 10, hue: "teal" },
  { left: "48%", bottom: "48px", delay: 1.2, duration: 12, hue: "amber" },
  { left: "55%", bottom: "26px", delay: 6.3, duration: 9.5, hue: "violet" },
  { left: "14%", bottom: "50px", delay: 3.7, duration: 10.5, hue: "amber" },
];

const SoulWisps = () => (
  <div className="souls-wisps" aria-hidden="true">
    {WISPS.map((w, i) => (
      <span
        key={i}
        className={`souls-wisp souls-wisp--${w.hue}`}
        style={{
          left: w.left,
          bottom: w.bottom,
          animationDelay: `${w.delay}s`,
          animationDuration: `${w.duration}s`,
        }}
      />
    ))}
  </div>
);

/* ------------------------------------------------------------------ */
/* Centerpiece — moon, soul lights, swinging lanterns, walking ghost   */
/* ------------------------------------------------------------------ */
export const SoulsCenterpiece = () => {
  if (!isSoulsMonth()) return null;

  return (
    <div className="souls-centerpiece" aria-hidden="true">
      <div className="souls-fog souls-fog--1" />
      <div className="souls-fog souls-fog--2" />
      <Moon />
      <Bats />
      <SoulWisps />

      <div className="souls-lantern souls-lantern--1">
        <div className="souls-lantern__string" />
        <Pumpkin className="souls-pumpkin--lantern" />
      </div>
      <div className="souls-lantern souls-lantern--2">
        <div className="souls-lantern__string" />
        <Pumpkin className="souls-pumpkin--lantern" />
      </div>

      <WalkingGhost />
    </div>
  );
};

/* ------------------------------------------------------------------ */
/* Corner decorations                                                  */
/* ------------------------------------------------------------------ */
export const SoulsDecorations = () => {
  if (!isSoulsMonth()) return null;

  return (
    <div className="souls-decor" aria-hidden="true">
      <Cobweb side="left" />
      <Cobweb side="right" />
      <Spider side="left" />
    </div>
  );
};

const SoulsMonthTheme = ({ children, className = "" }) => {
  if (!isSoulsMonth()) return children || null;

  return (
    <div className={`souls-month-theme-wrapper ${className}`}>
      <FloatingGhosts />
      <SoulsDecorations />
      <SoulsCenterpiece />
      {children}
    </div>
  );
};

export default SoulsMonthTheme;
